import { hotItems } from "@/mocks/gossip";

const trendIcon = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", cls: "text-secondary-600" },
  new: { icon: "ri-flashlight-fill", cls: "text-accent-600" },
} as const;

export default function RankSection() {
  return (
    <section id="rank" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-3 lg:gap-10">
          {/* 热榜列表 */}
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between">
              <div>
                <div className="mb-1 flex items-center gap-2 text-sm font-semibold text-primary-600">
                  <i className="ri-bar-chart-line"></i>
                  热度排行
                </div>
                <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">实时热榜追踪</h2>
              </div>
              <span className="hidden items-center gap-1 rounded-full bg-background-200/70 px-3 py-1 text-xs text-foreground-600 sm:flex">
                <i className="ri-time-line"></i>
                每30分钟更新
              </span>
            </div>

            <div className="mt-6 flex flex-col gap-3">
              {hotItems.map((item, i) => {
                const t = trendIcon[item.trend];
                return (
                  <div
                    key={item.rank}
                    className="flex items-center gap-4 rounded-xl border border-background-200 bg-background-100 px-4 py-3.5 transition-colors hover:border-background-300"
                  >
                    <span
                      className={`w-8 shrink-0 text-center font-heading text-xl font-black ${
                        i < 3 ? "text-primary-500" : "text-background-400"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2">
                        <h3 className="truncate text-sm font-semibold text-foreground-950 md:text-base">{item.title}</h3>
                        <span className={`flex shrink-0 items-center ${t.cls}`}>
                          <i className={t.icon}></i>
                        </span>
                      </div>
                      <div className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                        <span className="inline-flex items-center gap-1 rounded bg-background-200/70 px-1.5 py-0.5 font-medium">
                          {item.tag}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-fire-line"></i>
                          {item.heat}
                        </span>
                      </div>
                    </div>
                    <a
                      href="#hot"
                      className="hidden shrink-0 items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700 sm:inline-flex"
                    >
                      追踪
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                );
              })}
            </div>

            <a
              href="#hot"
              className="mt-5 inline-flex items-center gap-2 rounded-md bg-background-200/70 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-300/70"
            >
              查看更多热瓜
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* 追更卡片 */}
          <div className="flex flex-col">
            <div className="relative flex-1 overflow-hidden rounded-2xl border border-background-200 bg-background-950 p-6 md:p-7">
              <div className="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-primary-500/30 blur-2xl"></div>
              <div className="absolute -bottom-12 -left-8 h-36 w-36 rounded-full bg-accent-500/20 blur-2xl"></div>
              <div className="relative">
                <div className="flex items-center gap-2">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                    <i className="ri-megaphone-line text-xl"></i>
                  </span>
                  <div>
                    <div className="font-heading text-lg font-bold text-background-50">追更提醒</div>
                    <div className="text-xs text-background-200/80">第一时间同步新瓜与反转</div>
                  </div>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-background-200/90">
                  正在追某条瓜？开启追更提醒，当事件出现辟谣、反转或当事人回应时，我们会第一时间通过订阅推送给您，不再错过剧情大转折。
                </p>
                <div className="mt-5 flex flex-col gap-2.5">
                  {[
                    { icon: "ri-chat-check-line", t: "辟谣与澄清即时提醒" },
                    { icon: "ri-refresh-line", t: "反转与后续进展汇总" },
                    { icon: "ri-shield-check-line", t: "仅推送已核验信息" },
                  ].map((f) => (
                    <div key={f.t} className="flex items-center gap-2.5 text-sm text-background-100/90">
                      <i className={`${f.icon} text-accent-400`}></i>
                      {f.t}
                    </div>
                  ))}
                </div>
                <a
                  href="#subscribe"
                  className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-md bg-accent-500 px-4 py-3 text-sm font-bold whitespace-nowrap text-foreground-950 transition-colors hover:bg-accent-400"
                >
                  <i className="ri-notification-3-line"></i>
                  立即开启追更
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}